import { SHIPMENT_STAGES } from '#/entities/shipment'
import type { ShipmentStage } from '#/entities/shipment'

import { SHIPMENT_COMMENT_TAB } from './comment-panel-tabs'
import type { ShipmentCommentTab } from './comment-panel-tabs'

const NON_ORDER_HIDDEN_TABS: ShipmentCommentTab[] = [
  SHIPMENT_COMMENT_TAB.payment,
  SHIPMENT_COMMENT_TAB.contract,
]

export function hiddenCommentTabsForStage(
  stage: ShipmentStage,
): ShipmentCommentTab[] | undefined {
  return stage === SHIPMENT_STAGES.ORDER ? undefined : NON_ORDER_HIDDEN_TABS
}
